import { icons, type IconName } from './icons';

export type { IconName };

interface Props {
  name: IconName;
  size?: number;
  className?: string;
}

/** Inline Material Symbol (decorative; label the surrounding control instead). */
export function Icon({ name, size = 24, className }: Props) {
  return (
    <span
      className={className ? `icon ${className}` : 'icon'}
      style={{ width: size, height: size }}
      aria-hidden="true"
      // Icons are static, trusted SVG files bundled at build time.
      dangerouslySetInnerHTML={{ __html: icons[name] }}
    />
  );
}
